/* tslint:disable */
/* eslint-disable */
import { mapValues } from '../runtime';

export interface BankAccount {
  id?: number;
  courierId?: number;
  accountName?: string;
  bankName?: string;
  branch?: string;
  accountNumber?: string;
  accountType?: string;
  accountCategory?: string;
  routingNumber?: string;
  notes?: string;
  isActive?: boolean;
  sortOrder?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export function BankAccountFromJSON(json: any): BankAccount {
  return BankAccountFromJSONTyped(json, false);
}

export function BankAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccount {
  if (json == null) {
    return json;
  }
  return {
    'id': json['id'] == null ? undefined : json['id'],
    'courierId': json['courierId'] == null ? undefined : json['courierId'],
    'accountName': json['accountName'] == null ? undefined : json['accountName'],
    'bankName': json['bankName'] == null ? undefined : json['bankName'],
    'branch': json['branch'] == null ? undefined : json['branch'],
    'accountNumber': json['accountNumber'] == null ? undefined : json['accountNumber'],
    'accountType': json['accountType'] == null ? undefined : json['accountType'],
    'accountCategory': json['accountCategory'] == null ? undefined : json['accountCategory'],
    'routingNumber': json['routingNumber'] == null ? undefined : json['routingNumber'],
    'notes': json['notes'] == null ? undefined : json['notes'],
    'isActive': json['isActive'] == null ? undefined : json['isActive'],
    'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    'createdAt': json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    'updatedAt': json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
  };
}

export function BankAccountToJSON(value?: BankAccount | null): any {
  if (value == null) {
    return value;
  }
  return {
    'id': value['id'],
    'courierId': value['courierId'],
    'accountName': value['accountName'],
    'bankName': value['bankName'],
    'branch': value['branch'],
    'accountNumber': value['accountNumber'],
    'accountType': value['accountType'],
    'accountCategory': value['accountCategory'],
    'routingNumber': value['routingNumber'],
    'notes': value['notes'],
    'isActive': value['isActive'],
    'sortOrder': value['sortOrder'],
    'createdAt': value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    'updatedAt': value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
  };
}
